import { useState } from "react";
import { Box, Chip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss";
import { useTemplateLibraryStore } from "../../../../store/templateLibraryStore";
import { isTemplateCreated } from "../constant";

export type WrapWithHoverUIProps = {
    children: React.ReactNode;
    label: string;
    editable?: boolean;
    showEditIcon?: boolean;
    onEditClick?: (e: React.MouseEvent<HTMLElement>) => void;
    editContent?: React.ReactNode;
    onMouseLeave?: () => void;
    onHoverChange?: (hover: boolean) => void;
    chipPosition?: { left?: number; top?: number };
    editIconPosition?: { right?: number; top?: number };
    containerClassName?: string;
};

function WrapWithHoverUI({
    children,
    label,
    editable = false,
    showEditIcon = false,
    onEditClick,
    editContent,
    onMouseLeave,
    onHoverChange,
    chipPosition = { left: -25, top: -27 },
    editIconPosition = { right: -8, top: -8 },
    containerClassName,
}: WrapWithHoverUIProps) {

    const [hover, setHover] = useState(false);
    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);
    
    const canShowEditIcon = showEditIcon && !isTemplateCreated(createTemplatePayload);

    const setHoverState = (value: boolean) => {
        setHover(value);
        onHoverChange?.(value);
    };

    const handleMouseEnter = () => setHoverState(true);

    const handleMouseLeave = () => {
        setHoverState(false);
        onMouseLeave?.();
    };

    return (
        <Box
            position="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={`${styles.whatsappPreview__hoverContainer} ${containerClassName ?? ""}`.trim()}
        >
            {hover && (
                <Chip
                    size="small"
                    label={label}
                    className={styles.whatsappPreview__hoverChipTitle}
                    sx={{
                        position: "absolute",
                        left: chipPosition.left ?? -25,
                        top: chipPosition.top ?? -25,
                        zIndex: 1,
                    }}
                />
            )}
            {editable && canShowEditIcon && hover && onEditClick && (
                <IconButton
                    size="small"
                    onClick={onEditClick}
                    className={styles.whatsappPreview__hoverEditIcon}
                    sx={{
                        position: "absolute",
                        right: editIconPosition.right ?? -8,
                        top: editIconPosition.top ?? -8,
                        zIndex: 1,
                    }}
                >
                    <EditIcon sx={{ fontSize: "14px" }} />
                </IconButton>
            )}
            {children}
            {editContent}
        </Box>
    );
}

export default WrapWithHoverUI;
